import axios from "axios"
import router from "@/router"
import { auth as api } from "@/backend/api"
// import CryptoJS from 'crypto-js'

const state = {
  token: "",
  refresh: "",
  expires_in: 0,
  refresh_expires_in: 0,
  user: {},
  account: {},
  userAccount: {},
  invitation: {},
  trace: {}
}

const actions = {
  SIGN_UP: ({ commit }, { user, invitation }) => {
    return new Promise((resolve, reject) => {
      api
        .signUp(user, invitation)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  GET_AUTH: ({ commit }, { resource, payload }) => {
    return new Promise((resolve, reject) => {
      api
        .getAuth(resource, payload)
        .then((response) => {
          commit("SET_AUTH", response)
          api
            .getUser()
            .then((response) => {
              // const user = response.data
              commit("SET_USER", response.data)

              // window.analytics.identify(user.email, {
              //   email: user.email
              // })
              // }, {
              //   integrations: {
              //     Intercom: {
              //       user_hash: user.intercom.hash
              //     }
              //   }
              // })
            })
            .catch((error) => {
              reject(error)
            })
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  DELETE_AUTH: ({ commit }) => {
    commit("DELETE_AUTH")
  },
  SET_ACCOUNT: ({ commit }, { account, redirect = true }) => {
    commit("SET_ACCOUNT", { account, redirect: redirect })
  },
  TOKEN_VERIFY: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      api
        .tokenVerify(state.refresh)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  REFRESH_TOKEN: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      api
        .getRefreshToken(state.refresh)
        .then((response) => {
          commit("REFRESH_TOKEN", response.data)
          resolve(response)
        })
        .catch((error) => {
          commit('DELETE_AUTH')
          reject(error)
        })
    })
  },
  ACCEPT_INVITATION: ({ commit }, { key, payload }) => {
    return new Promise((resolve, reject) => {
      api
        .acceptInvitation(key, payload)
        .then((response) => {
          commit("SET_INVITATION", response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  PASSWORD_RESET: ({ commit }, email) => {
    return new Promise((resolve, reject) => {
      api
        .passwordReset(email)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  PASSWORD_RESET_CONFIRM: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      api
        .passwordResetConfirm(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  GET_USER: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .getUser()
        .then((response) => {
          resolve(response)
          commit("SET_USER", response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  PATCH_USER: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      api
        .patchUser(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  POST_USER_PASSWORD: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      api
        .postUserPassword(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  RETRIEVE_TRACE: ({ commit }) => {
    return new Promise((resolve, reject) => {
      api
        .retrieveTrace()
        .then((response) => {
          commit("SET_TRACE", response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const mutations = {
  SET_AUTH: (state, payload) => {
    if (payload) {
      state.token = payload?.data?.access_token
      state.refresh = payload?.data?.refresh_token
      state.expires_in = payload?.data?.expires_in
      state.refresh_expires_in = payload?.data?.refresh_expires_in
      // state.user = JSON.parse(atob(state.token.split(".")[1]))
      state.user.authenticated = true
      router.push("/account/choose")
    }
  },
  DELETE_AUTH: (state) => {
    state.token = ""
    state.refresh = ""
    state.tokenExpiresIn = 0
    state.refresh_expires_in = 0
    state.user = {}
    state.account = {}
    delete axios.defaults.headers.common.Authorization
    router.push('/auth/signin').catch(() => {})
  },
  SET_ACCOUNT: (state, { account, redirect }) => {
    // Parse options string to array (separated by space or comma)
    if (account.options && typeof account.options === 'string') {
      account.options = account.options.split(/[\s,]+/).filter(opt => opt.length > 0)
    } else {
      account.options = []
    }
    state.account = account
    if (redirect) {
      router.push({ name: "AccountDashboard" })
    }
  },
  REFRESH_TOKEN: (state, payload) => {
    state.token = payload?.access_token
    state.refresh = payload?.refresh_token
    state.expires_in = payload?.expires_in
    state.refresh_expires_in = payload?.refresh_expires_in
  },
  SET_INVITATION: (state, invitation) => {
    state.invitation = invitation
  },
  SET_TRACE: (state, data) => {
    const trace = {}
    data.split("\n").forEach((prop) => {
      const cleaned = prop.trim().split("=")
      trace[cleaned[0]] = cleaned[1]
    })
    state.trace = trace
  },
  SET_USER: (state, userAccount) => {
    state.userAccount = userAccount
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
